/**
 * @module FooterMenu
 * @description
 */
import React, { FC, useState } from 'react';
import Link from 'next/link';
import { Navigation, Menu } from 'ui/components/Navigation';
import styles from '../styles/FooterMenu.module.css';

interface SubmenuItem {
  href: string;
  title: string;
  target?: string;
}

interface MenuItem {
  title: string;
  links: SubmenuItem[];
}

interface Props {
  className?: string;
  links: MenuItem[];
}

const FooterMenu: FC<Props> = ( { ...props } ) => {
  const {
    links
  } = props;

  const [ active, setActive ] = useState<number | null>( null );

  const toggleActive = ( index: number ) => {
    if( index === active ) {
      setActive( null );
      return;
    }

    setActive( index );
  }

  return (
    <Navigation className={ styles.navigation } ariaLabel="Footer Navigation">
      <div className={ styles.container }>
        { links.map( ( link: MenuItem, index: number ) => (
            <div key={ index } className={ styles.menuColumn } data-active={ index === active }>
              <button
                className={ styles.menuBtn }
                role="button"
                aria-expanded={ index === active }
                aria-controls={ `footer-menu-column-${ index }` }
                onClick={ () => toggleActive( index ) }
              >
                <span className={ styles.menuTitle }>{ link.title }</span>
              </button>
              <div className={ styles.menuWrap } id={ `footer-menu-column-${ index }` }>
                <Menu className={ styles.ul } ariaLabel="Footer Menu">
                  <>
                  { link.links.map( ( link: SubmenuItem, index1: number ) => (
                      <li key={ index1 } className={ styles.li } role="menuitem">
                        <Link
                          href={ link.href }
                          target={ link.target }
                          className={ styles.a }
                        >
                          { link.title }
                        </Link>
                      </li>
                    ) ) }
                  </>
                </Menu>
              </div>
            </div>
        ) ) }
      </div>
    </Navigation>
  );
};

FooterMenu.displayName = 'FooterMenu';

export default FooterMenu;
